module.exports = __webpack_public_path__ + "media/images/products/marketplace/call-center-7e8f469dc3d6956a83f3644903312ed4.png";